export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/gerrit-vermeulen-821507c363edd35eef184d4f763deb97.jpg";